class RxHubMissingComponent {
  constructor(Orders) {
    Object.assign(this, {
      Orders,
      missing: [],
    });
  }
}

RxHubMissingComponent.$inject = ['Orders'];
angular.module('pims').component('rxHubMissingTable', {
  templateUrl: 'app/views/visits/list/tabs/rx-hub/table/missing/rx-hub-missing.component.html',
  controller: RxHubMissingComponent,
  controllerAs: 'vm',
  bindings: {
    missing: '='
  }
});
